export class Socio {

   public id:number;
   public codigoConsorcio:string;
   public codigoSocio:string;
   public tipo:string;
   public nombre:string;
   public direccion:string;
   public telefono:string;
   public email:string;
   public web:string;
   public referenciaERP:string;
   public contacto:string;
   
}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/socio.ts